import { render, staticRenderFns } from "./questionCopy.vue?vue&type=template&id=8adf10ea&scoped=true"
import script from "./questionCopy.vue?vue&type=script&lang=js"
export * from "./questionCopy.vue?vue&type=script&lang=js"
import style0 from "./questionCopy.vue?vue&type=style&index=0&id=8adf10ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adf10ea",
  null
  
)

export default component.exports